var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"77419fead3327f2913ad3d3424009e0f5a55c0c3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["docupet-app-order@docupet"]={id:"77419fead3327f2913ad3d3424009e0f5a55c0c3"};
      